// Copyright (c) 2017 Deere & Company

import LaborRate from '../../claim/labor-rate-dealers';
import laborRateChangeRoute from './labor-rate-change';
import massLaborRateChangeRoute from './mass-labor-rate-change';
import massLaborRateRequestStatusRoute from './mass-labor-rate-request-status';

export default {
    childRoutes: [
        laborRateChangeRoute,
        massLaborRateChangeRoute,
        massLaborRateRequestStatusRoute
    ],
    component: LaborRate,
    name: 'UPDATE_LABOR_RATES',
    path: 'labor-rates'
};



// WEBPACK FOOTER //
// ./src/routes/claims/labor-rate-dealers.js